import { get } from "lodash";

export default order =>
  Boolean(get(order, "values.has_eventbrite_credentials.value"));
